<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'energy_savings' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <ng-container class="contentDiv">
      <div class="bordered-button" (click)="openBasicdata()">
        <ion-icon name="eye-outline"></ion-icon>
        <span>{{'EDIT_CALCULATION_DATA' | translate}}</span>
      </div>
      <div class="bordered-button" (click)="clickSeeComparedConfig()">
        <ion-icon name="eye-outline"></ion-icon>
        <span>{{'see_compared_config' | translate}}</span>
      </div>
      <div class="form-container">
        <div class="select-group">
          <ion-label class="select-label">{{'season' | translate}}</ion-label>
          <ion-radio-group [value]="selectedOption" [(ngModel)]="selectedOption" (ionChange)="onSeasonChange()">

            <ion-item class="selection-item" button detail="false">
              <ion-radio slot="start" value="winter" labelPlacement="end" mode="md">
                <div class="radio-content">
                  <ion-label class="option-label">
                    <p>{{'winter_only' | translate}}</p>
                  </ion-label>
                </div>
              </ion-radio>
            </ion-item>

            <ion-item class="selection-item" button detail="false">
              <ion-radio slot="start" value="summer" labelPlacement="end" mode="md">
                <div class="radio-content">
                  <ion-label class="option-label">
                    <p>{{'summer_only' | translate}}</p>
                  </ion-label>
                </div>
              </ion-radio>
            </ion-item>

            <ion-item class="selection-item" button detail="false">
              <ion-radio slot="start" value="both" labelPlacement="end" mode="md">
                <div class="radio-content">
                  <ion-label class="option-label">
                    <p>{{'winter_summer' | translate}}</p>
                  </ion-label>
                </div>
              </ion-radio>
            </ion-item>

          </ion-radio-group>

        </div>

        <div class="input-with-controls-group">
          <ion-label class="select-label">{{'qty_windows' | translate}}</ion-label>

          <ion-row>
            <ion-col>
              <div class="input-with-controls">
                <ion-input class="bordered-input" type="number" [(ngModel)]="eQty" name="eQty"
                  (ionInput)="validateForm()" (ionBlur)="validateForm()">
                </ion-input>

                <!-- Control buttons container -->
                <div class="input-controls">
                  <ion-button fill="clear" size="small" class="control-btn decrement-btn" (click)="decrementQty()">
                    <ion-icon name="remove-outline"></ion-icon>
                  </ion-button>

                  <ion-button fill="clear" size="small" class="control-btn increment-btn" (click)="incrementQty()">
                    <ion-icon name="add-outline"></ion-icon>
                  </ion-button>
                </div>
              </div>

            </ion-col>
            <ion-col>
              <div class="disabledInput">
                <p>{{ totalWindowArea }} m²</p>
              </div>
            </ion-col>

          </ion-row>
        </div>

        <div class="input-with-controls-group">
          <ion-label class="select-label">{{'heating_colling_seasons' | translate}}</ion-label>

          <div class="input-with-controls">
            <ion-input class="bordered-input" type="number" [(ngModel)]="eYrs" name="eYrs" (ionInput)="validateForm()"
              (ionBlur)="validateForm()">
            </ion-input>

            <!-- Control buttons container -->
            <div class="input-controls">
              <ion-button fill="clear" size="small" class="control-btn decrement-btn" (click)="decrementYrs()">
                <ion-icon name="remove-outline"></ion-icon>
              </ion-button>

              <ion-button fill="clear" size="small" class="control-btn increment-btn" (click)="incrementYrs()">
                <ion-icon name="add-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
      </div>
      <div class="descDiv input-with-controls-group">
        <div *ngIf="this.selectedOption == 'winter' || this.selectedOption == 'both'">
          <h5>{{'winter' | translate}}</h5>
          <ion-label class="select-label">{{'diff_heating_reqd' | translate}}</ion-label>
          <p>{{ winterResults?.diffHeatRequirements || '0.00' }} kWh</p>
          <ion-label class="select-label">{{'diff_fuel_reqd' | translate}}</ion-label>
          <p>{{ winterResults?.diffHeatDemand || '0.00' }} {{ basicData?.winter?.heatingUnit || '' }}</p>
          <ion-label class="select-label">{{'diff_energy_cost_winter' | translate}}</ion-label>
          <p>{{ winterResults?.diffHeatCosts || '0.00' }} {{ basicData?.winter?.heatingCurrency || '' }}</p>
          <ion-label class="select-label">{{'diff_co2_emission_winter' | translate}}</ion-label>
          <p>{{ winterResults?.diffCO2 || '0.00' }} kg</p>
        </div>
        <div *ngIf="this.selectedOption == 'summer' || this.selectedOption == 'both'">
          <hr class="divider" *ngIf="this.selectedOption == 'both'">
          <h5>{{'summer' | translate}}</h5>
          <ion-label class="select-label">{{'diff_cooling_req' | translate}}</ion-label>
          <p>{{ summerResults?.diffCoolRequirements || '0.00' }} kWh</p>
          <ion-label class="select-label">{{'diff_energy_cost_summer' | translate}}</ion-label>
          <p>{{ summerResults?.diffCoolCosts || '0.00' }} {{ basicData?.summer?.electricalCurrency || '' }}</p>
          <ion-label class="select-label">{{'diff_co2_emission_summer' | translate}}</ion-label>
          <p>{{ summerResults?.diffCO2 || '0.00' }} kg</p>
        </div>
        <div *ngIf="this.selectedOption == 'both'">
          <hr class="divider" *ngIf="this.selectedOption == 'both'">
          <h5>{{'winter_summer' | translate}}</h5>
          <ion-label class="select-label">{{'diffheating_colling_req' | translate}}</ion-label>
          <p>{{ bothResults?.diffHeatCoolRequirements || '0.00' }} kWh</p>
        </div>
        <p>{{'cal_winter_summer_details' | translate}}</p>
      </div>

      <ion-chip color="primary" class="customChip primaryClass">
        <ion-label>
          <div class="chip-content">
            <div class="chip-title">{{'results' | translate}}</div>
            <div class="chip-description">
              <ul>
                <li *ngIf="getTotalEnergyCostSavings() > 0">
                  {{'energy_costs_savings' | translate}} = {{ getTotalEnergyCostSavings() | number:'1.2-2' }} {{
                  getCurrency() }}
                </li>
                <li *ngIf="getTotalCO2Savings() > 0">
                  {{'co2_emissions_savings' | translate}} = {{ getTotalCO2Savings() | number:'1.1-1' }} kg
                </li>
              </ul>
            </div>
          </div>
        </ion-label>
      </ion-chip>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button class="next-btn" (click)="validate()" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>